import React, { memo } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';

interface Props extends SvgIconProps {
  alt?: boolean;
  dark?: boolean;
}

function SixWheelerTruck({ dark = false, alt, ...props }: Props) {
  const { palette }: Theme = useTheme();

  const contrastForeground = dark ? palette.accent.main : palette.primary.main;
  const contrastBackground = dark ? palette.primary.dark : palette.accent.main;

  const foreground = contrastForeground;
  const background = alt ? palette.common.white : contrastBackground;

  return (
    <SvgIcon width={42} height={36} {...props} viewBox="0 0 42 36">
      <g fill="none" fillRule="evenodd">
        <path
          d="M35 32c0 2.2-2 4-4.1 4-2 0-3.9-2-3.9-4s2-4 3.9-4c2.2 0 4.1 1.9 4.1 4m-23-.1c.1 2-1.8 4-4 4.1-2 0-4-1.8-4-3.9 0-2 1.9-4 4-4.1 1.8 0 3.9 2 4 3.9m9 0c.1 2-1.8 4-4 4.1-2 0-4-1.8-4-3.9 0-2 1.9-4 4-4.1 1.8 0 3.9 2 4 3.9m.4-15.4c-1.8 2.8-5 4-7.9 3.3l-.5-.3a71 71 0 01-3.4-1.8L.6 11c-.6-.4-.7-.8-.5-1.7.3-1.2.6-2.7 1-3.8.3-1.4.6-1.7 2-1.8 3.6-.2 9.1-1 13.2-.6 3 .6 4.9 2.2 6 5 1.2 3 .9 5.8-.9 8.4"
          fill={background}
        />
        <path d="M15 29" fill={foreground} />
        <path d="M2.1 0H42v34H2z" />
        <path
          d="M40.1 24v3.2h-3.8a4.2 4.2 0 00-3.6-2.4c-1.3 0-2.5.7-3.3 1.7v-4.3h9.2c1.5 0 1.5 0 1.5 1.7zM35 29.3c0 1.4-1 2.5-2.2 2.5-1.3 0-2.3-1.1-2.3-2.5 0-1 .5-1.8 1.3-2.2a2.1 2.1 0 012 0c.7.4 1.2 1.2 1.2 2.2zm-5.5-16.7h5c.2 0 .4.2.5.3 1.6 2.3 2.4 4.6 4.2 7.1h-9.7v-7.4zm-2 14.6H23a4.2 4.2 0 00-3.7-2.5c-1.6 0-3 1-3.8 2.5h-1a4.2 4.2 0 00-3.6-2.5c-1.7 0-3 1-3.8 2.5h-3v-5l23.2-.1v5zm-6 2.1c0 1.4-1 2.5-2.2 2.5-1.3 0-2.3-1.1-2.3-2.5 0-1 .5-1.7 1.2-2.1a2.1 2.1 0 012.2 0c.7.4 1.1 1.2 1.1 2.1zm-8.4 0c0 1.4-1 2.5-2.2 2.5-1.3 0-2.3-1.1-2.3-2.5 0-1 .5-1.7 1.2-2.1a2.1 2.1 0 012.1 0c.7.4 1.2 1.2 1.2 2.1zm-8.4-22l.7-2.9c.3-1.2.8-1.8 2-1.9L17 2l-3.1 13c-.4 0-.7-.1-.9-.3L5.1 8.9c-.5-.4-.7-.7-.5-1.4zM24.3 16v4H6.6v-7.4l5 3.4c2.1 1.5 4.4 2.8 7.1 2.5 2.1-.2 3.8-1.2 5.6-2.7zM18.9 2c2.6.5 4.3 1.9 5.2 4.3 1.1 2.5.8 5-.7 7.2a6.4 6.4 0 01-7 2.8c-.5-.2-.8-.4-.6-1L18.9 2zm23 19.4c0-.5-.2-1-.4-1.4-2-2.9-3.1-5.7-5.2-8.5-.3-.5-1-.9-1.6-.9h-5.8c-1 0-1.5.4-1.5 1.6v7c0 .7-.2 1-.8.9h-.3v-.6c0-2.7-.2-5.5.2-8.1.7-4.7-1.2-9.2-5.3-10.8a13 13 0 00-5.1-.6C12.5.2 8.9.6 5.3.9c-.8 0-1.1.5-1.3 1.3L2.7 6.9c-.6 2.2-.6 2.2 1 3.5.7.5 1 1 .9 1.7V19c0 1 .2 1.3-.7 1.3h-.5.1c-1 0-1.4.4-1.4 1.5v6c0 1.5.2 1.7 1.6 1.7h2.8c0 2.5 2 4.6 4.3 4.6 2.1 0 4-1.8 4.2-4.1v-1 1c.2 2.3 2 4 4.2 4 2.3 0 4.2-2 4.2-4.5h5c0 2.5 2 4.6 4.3 4.6s4.2-2 4.2-4.6h3.7c1 0 1.4-.5 1.4-1.5v-6.4zM15 29"
          fill={foreground}
        />
      </g>
    </SvgIcon>
  );
}

export default memo(SixWheelerTruck);
